import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {fetchUserAlbums} from "../../creators/user.albums";
import {moveMedia} from "../../creators/media";

import {Button} from "./Button";
import {PageLoader} from "./Loader";
import createLink from "../../libs/createLink";
import history from "../../libs/history";

class MoveMedia extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentAlbum: this.props.activeAlbumId,
            loading : false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.props.fetchUserAlbums(this.props.ownerId, {limit : false});
    }

    handleSubmit() {
        let currentAlbum = this.props.userAlbums.filter(album => album._id === this.state.currentAlbum);
        this.setState({loading : true}, ()=>{
            this.props.moveMedia(this.props.mediaId, {album: this.state.currentAlbum}).then(response=>{
                history.push(createLink(this.props.ownerId === this.props.currentUser._id ? "userMeAlbum" : "userAlbum", {...currentAlbum[0].owner, album : {slug: currentAlbum[0].slug, _id : currentAlbum[0]._id} }));
                this.props.handleClose();
            })
        });
    }

    render() {
        return !this.props.userAlbumsInitialized ? (
            <div id="shift" className={"modal-container"}>
                <PageLoader/>
            </div>
        ) : (
            <div id="shift" className={"modal-container"}>
                <div className={"modal-topline"}>
                    <div className="head-title border-bottom">Déplacer votre media</div>
                </div>
                <div className={"modal-body"}>
                    {this.props.userAlbumsLoading ? <PageLoader/> : (
                        <select className="full" onChange={(event) => this.setState({currentAlbum: event.target.value})}
                                value={this.state.currentAlbum}>
                            <option disabled value="0">Déplacer vers :</option>
                            {this.props.userAlbums.map((item) =>
                                <option key={item._id} value={item._id}>{item.title}</option>)}
                        </select>
                    )}
                </div>
                <div className={"modal-baseline"}>
                    <Button size={"small"}
                            btnStyle={"grey"}
                            onClick={() => this.props.handleClose()}
                            content={"Annuler"}/>
                    <Button size={"small"}
                            btnStyle={"primary-reverse"}
                            disabled={this.state.loading}
                            loading={this.state.loading}
                            onClick={() => !this.state.loading ? this.handleSubmit() : null}
                            content={"Valider"}/>
                </div>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userAlbums: state.userAlbums.data,
        userAlbumsLoading: state.userAlbums.loading,
        userAlbumsInitialized: state.userAlbums.initialized,

        currentUser: state.currentUser.data,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserAlbums,
    moveMedia
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MoveMedia);